"use client";

import { useState } from "react";

import StarIcon from "@repo/ui-system/icons/rating/star/outline.svg";

import { type BestQuickPicks } from "@/lib/api/best/quick-picks/schema";
import { cn } from "@/lib/utils";

import { getCategoriesFromData, type Category } from "../categories";
import { QuickPickCard } from "./quick-pick-card";

type Props = {
  items: BestQuickPicks;
};

export function QuickPicks({ items }: Props) {
  const categories = getCategoriesFromData(items);
  const [activeCategory, setActiveCategory] = useState<
    Category["id"] | undefined
  >(categories[0]?.id);

  if (!activeCategory) return null;

  const filteredItems = items.filter(
    (item) => item.category === activeCategory,
  );

  return (
    <div className="bg-surface-grayscale-default flex flex-col gap-4 rounded-2xl p-4">
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2">
          <StarIcon className="size-4 text-text-grayscale-subtitle" />
          <p className="mini1 font-medium text-text-grayscale-subtitle">
            Quick Picks
          </p>
        </div>
        <p className="body2 text-text-grayscale-caption">
          Picked based on what people buy, love, and recommend. No noise, just
          clarity.
        </p>
      </div>

      <div className="flex flex-col gap-4">
        <div className="flex justify-between border-b border-border-grayscale-darker">
          {categories.slice(0, 3).map((category) => (
            <button
              key={category.id}
              onClick={() => setActiveCategory(category.id)}
              className={cn(
                "flex-1 mini2 font-medium border-b-2 py-1 capitalize text-text-grayscale-body transition-all duration-200 ease-out",
                activeCategory === category.id
                  ? "border-primary text-primary"
                  : "border-transparent",
              )}
            >
              {category.label}
            </button>
          ))}
        </div>

        <div className="flex flex-col gap-3">
          {filteredItems.slice(0, 3).map((item) => (
            <QuickPickCard
              key={`${item.category}:${item.id}`}
              item={item}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
